import { useContext, useState } from 'react'
import { __ } from '@wordpress/i18n'
import ModalContainer from '../Global/ModalContainer';
import Button from './Button';
import Source from './Source';
import CustomizerSourcesModal from '../Modals/CustomizerSourcesModal';
import SbUtils from '../../Utils/SbUtils';
import {
    getSourceBadge as getWooSourceBadge,
    getSourceProducts,
    getSourceCategories as getWooSourceCategories,
    getSourceTags as getWooSourceTags
} from '../../Utils/WooCommerceSourceUtils';
import {
    getSourceBadge as getEddSourceBadge,
    getSourceDownloads,
    getSourceCategories as getEddSourceCategories,
    getSourceTags as getEddSourceTags
} from '../../Utils/EddSourceUtils';

/**
 * Get badge text for any source type (WooCommerce or EDD)
 * @param {Object} source - The source object
 * @return {string|null} Badge text or null
 */
const getSourceBadge = ( source ) => {
    if ( source?.provider === 'edd' ) {
        return getEddSourceBadge( source );
    }
    return getWooSourceBadge( source );
};

/**
 * Get categories for any source type (WooCommerce or EDD)
 * @param {Object} source - The source object
 * @return {Array|null} Categories array or null
 */
const getSourceCategories = ( source ) => {
    if ( source?.provider === 'edd' ) {
        return getEddSourceCategories( source );
    }
    return getWooSourceCategories( source );
};

/**
 * Get tags for any source type (WooCommerce or EDD)
 * @param {Object} source - The source object
 * @return {Array|null} Tags array or null
 */
const getSourceTags = ( source ) => {
    if ( source?.provider === 'edd' ) {
        return getEddSourceTags( source );
    }
    return getWooSourceTags( source );
};

/**
 * Get products/downloads for any source type
 * Returns products for WooCommerce, downloads for EDD
 * @param {Object} source - The source object
 * @return {Array|null} Products/downloads array or null
 */
const getSourceProductsOrDownloads = ( source ) => {
    if ( source?.provider === 'edd' ) {
        return getSourceDownloads( source );
    }
    return getSourceProducts( source );
};

const FeedSources = ( props ) => {
    const {
        addSModal,
        isLoadingReviews
    } = useContext( SbUtils.getCurrentContext() );
    const activeSources = props?.feedSourcesList || []

    const [ sourcesModalActive, setSourcesModalActive ] = useState( false );

    const removeSource = ( source ) => {
        // Support both id (Review Alerts) and account_id (regular feeds)
        // Check which identifier exists in props.value and remove it
        const valueAsStrings = ( props?.value || [] ).map( v => String( v ) );
        let indexToRemove = valueAsStrings.indexOf( String( source.id ) );
        if ( indexToRemove === -1 ) {
            indexToRemove = valueAsStrings.indexOf( String( source.account_id ) );
        }
        if ( indexToRemove !== -1 ) {
            const newValue = [ ...props.value ];
            newValue.splice( indexToRemove, 1 );
            props.onChange( newValue );
        }
    }

    return(
        <>
            {
                activeSources.map( ( source, sourceInd ) => {
                    return (
                        <Source
                            customClass='sb-source-control-item'
                            key={ sourceInd }
                            provider={ source.provider }
                            checkbox={ false }
                            name={ source.name }
                            info={ source.info }
                            badge={ getSourceBadge( source ) }
                            productsInfo={ getSourceProductsOrDownloads( source ) }
                            categoriesInfo={ getSourceCategories( source ) }
                            tagsInfo={ getSourceTags( source ) }
                            removeIcon={ true }
                            removeDisabled={ isLoadingReviews }
                            onRemoveClick={ () => {
                                removeSource( source )
                            }}
                        />
                    )
                } )
            }
            <Button
                customClass='sb-sources-chooser-btn'
                icon='plus'
                iconPosition='left'
                size='small'
                full-width={ true }
                type='secondary'
                disabled={ isLoadingReviews }
                onClick={ () => {
                    setSourcesModalActive( true )
                }}
                text={ __( 'Add another Source', 'sb-customizer' ) }
            />
            {
                (sourcesModalActive ||  ( props.fbManualModal?.connectFacebookManualActive !== undefined && props.fbManualModal?.connectFacebookManualActive === null ) ) &&
                <ModalContainer
                    size={SbUtils.getAddSourceModalSize(addSModal?.modalType === 'freeRetriever')}
                    closebutton={true}
                    onClose={ () => {
                        setSourcesModalActive( false )
                        props.fbManualModal.setConnectFacebookManualActive(false)
                    } }
                >
                    <CustomizerSourcesModal
                        sources={ props.sources }
                        selectedSources={ props?.value }
                        fbModal={ props.fbModal }
                        useDbId={ props.useDbId }
                        onCancel={ () => {
                            setSourcesModalActive( false )
                            props.fbManualModal.setConnectFacebookManualActive(false)
                        } }
                        onUpdateSources={ ( element ) => {
                            props.onChange( element )
                            setSourcesModalActive( false )
                            props.fbManualModal.setConnectFacebookManualActive(false)
                        } }
                    />
                </ModalContainer>
            }
        </>
    )
}
export default FeedSources;